const homepageVideo = document.querySelectorAll('.homepage-video');

if (homepageVideo.length > 0) {
  let homepageVideoModule = null;
  const videoModuleTimeline = new TimelineLite();

  const initHomepageVideoScrollMagic = () => {
    homepageVideoModule = new ScrollMagic.Controller();

    homepageVideo.forEach((element) => {
      const parentElem = element.closest('.sc-homepage-video');
      const startPoint = parentElem.querySelector('.homepage-video__animation-start');
      const mainVideo = parentElem.querySelector('.homepage-video__inner');

      const videoTween = videoModuleTimeline.to(mainVideo, {
        width: '102vw',
        height: '102vh',
      });

      // Video enlarge animation
      new ScrollMagic.Scene({
        triggerElement: startPoint,
        duration: '70%',
        triggerHook: 1,
      })
        .on('enter', () => {
          mainVideo.classList.add('hide-triangle');
        })
        .on('progress', (e) => {
          element.classList.toggle('full-video', e.progress >= 0.95);
        })
        .on('leave', (e) => {
          if (e.scrollDirection === 'REVERSE') {
            mainVideo.classList.remove('hide-triangle');
          }
        })
        .setTween(videoTween)
        .addTo(homepageVideoModule);

      // Sticky section for a while
      const stickyStart = parentElem.querySelector('.homepage-video__sticky-start');
      const stickyElem = parentElem.querySelector('.homepage-video');
      new ScrollMagic.Scene({
        triggerElement: stickyStart,
        duration: stickyStart.clientHeight,
        triggerHook: 0,
      })
        .setPin(stickyElem)
        .addTo(homepageVideoModule);
    });
  };
  initHomepageVideoScrollMagic();
}
